import * as React from "react"
const ArrowIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={12}
        fill="none"
        {...props}
    >
        <path
            fill="#CBCBCB"
            d="m16 6-5.5 5.5-1.063-1.063 3.688-3.687H7v-1.5h6.125L9.437 1.562 10.5.5 16 6Zm-10.5.75H3v-1.5h2.5v1.5Zm-4 0H0v-1.5h1.5v1.5Z"
        />
    </svg>
)
export default ArrowIcon
